import { SeoProps } from '../../components/Seo'

export const recipesByTagSeoTransformer = (t: any, tag: string): SeoProps => {
  return {
    title: `${t('seo_title_recipe_by_tag', {
      tag,
    })} ${t('site_title_suffix_manger_mieux')}`,
    description: `${t('seo_description_recipe_by_tag', { tag })} ${t(
      'site_description_suffix_manger_mieux'
    )}`,
  }
}
